<div class="login-wrapper">
    <div class="particles">
        <div class="particle particle-1"></div>
        <div class="particle particle-2"></div>
        <div class="particle particle-3"></div>
        <div class="particle particle-4"></div>
        <div class="particle particle-5"></div>
    </div>

    <div class="login-container animate__animated animate__fadeIn">
        <div class="login-panel">
            <div class="panel-content">
                <div class="logo-wrapper">
                    <img src="assets/images/logo/logo-icon.png" alt="Logo" class="logo-pulse">
                    <h1 class="brand-name mb-3">WAREHOUSE</h1>
                    <div class="barcode "></div>
                </div>
                <div class="panel-text">
                    <h2>Get Started</h2>
                    <p>Create your warehouse management account to access all features</p>
                </div>
                <div class="panel-features">
                    <div class="feature">
                        <i class="fas fa-boxes"></i>
                        <span>Inventory Tracking</span>
                    </div>
                    <div class="feature">
                        <i class="fas fa-robot"></i>
                        <span>Automated Reports</span>
                    </div>
                    <div class="feature">
                        <i class="fas fa-chart-line"></i>
                        <span>Advanced Analytics</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="login-form-container">
            <form class="login-form" [formGroup]="registerForm" (ngSubmit)="onSubmit()" autocomplete="off">
                <div class="form-header">
                    <h3>Create Account</h3>
                    <p>Enter your details to register</p>
                </div>

                <div class="form-group animate__animated animate__fadeInRight">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-user"></i>
                        <input type="text" id="name" placeholder=" " formControlName="name" autocomplete="off"
                            autocorrect="off" autocapitalize="none" spellcheck="false">
                        <label for="name">Username</label>
                        <div class="input-bar"></div>
                    </div>
                    <div
                        *ngIf="registerForm.get('name')?.touched && registerForm.get('name')?.errors?.['required']">
                        <span class="custom-text-danger">Username is required</span>
                    </div>
                </div>

                <div class="form-group animate__animated animate__fadeInRight animate__delay-1s">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-envelope"></i>
                        <input type="email" id="email" placeholder=" " formControlName="email" autocomplete="off"
                            autocorrect="off" autocapitalize="none" spellcheck="false">
                        <label for="email">Email Address</label>
                        <div class="input-bar"></div>
                    </div>
                    <div *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.errors?.['required']">
                        <span class="custom-text-danger">Email is required</span>
                    </div>
                    <div *ngIf="registerForm.get('email')?.touched && registerForm.get('email')?.errors?.['email']">
                        <span class="custom-text-danger">Please enter a valid email</span>
                    </div>
                </div>

                <div class="form-group animate__animated animate__fadeInRight animate__delay-2s">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-lock"></i>
                        <input [type]="show ? 'text' : 'password'" id="password" placeholder=" "
                            formControlName="password" autocomplete="new-password" autocorrect="off"
                            autocapitalize="none" spellcheck="false">
                        <label for="password">Password</label>
                        <div class="input-bar"></div>
                        <button type="button" class="password-toggle" (click)="showPassword()">
                            <i class="fas" [ngClass]="{'fa-eye': !show, 'fa-eye-slash': show}"></i>
                        </button>
                    </div>
                    <div
                        *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['required']">
                        <span class="custom-text-danger">Password is required</span>
                    </div>
                    <div
                        *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['minlength']">
                        <span class="custom-text-danger">Minimum 8 characters required</span>
                    </div> 
                    <div 
                        *ngIf="registerForm.get('password')?.touched && registerForm.get('password')?.errors?.['pattern']">
                        <span class="custom-text-danger">Include uppercase, lowercase, number and special character</span>
                    </div>
                </div>

                <div class="form-group animate__animated animate__fadeInRight animate__delay-3s">
                    <div class="input-wrapper">
                        <i class="input-icon fas fa-lock"></i>
                        <input [type]="show ? 'text' : 'password'" id="confirmPassword" placeholder=" "
                            formControlName="confirmPassword" autocomplete="new-password" autocorrect="off"
                            autocapitalize="none" spellcheck="false">
                        <label for="confirmPassword">Confirm Password</label>
                        <div class="input-bar"></div>
                    </div>
                    <div
                        *ngIf="registerForm.get('confirmPassword')?.touched && registerForm.get('confirmPassword')?.errors?.['required']">
                        <span class="custom-text-danger">Please confirm your password</span>
                    </div>
                    <div *ngIf="registerForm.errors?.['mismatch'] && registerForm.get('confirmPassword')?.touched">
                        <span class="custom-text-danger">Passwords do not match</span>
                    </div>
                </div>

                <div class="form-group animate__animated animate__fadeInUp animate__delay-5s">
                    <button class="login-button" [disabled]="registerForm.invalid || isLoading" type="submit">
                        <span class="button-content" *ngIf="!isLoading">
                            <span>CREATE ACCOUNT</span>
                            <i class="fas fa-user-plus button-icon"></i>
                        </span>
                        <span class="loading-content" *ngIf="isLoading">
                            <i class="fas fa-circle-notch fa-spin"></i>
                            <span>CREATING ACCOUNT...</span>
                        </span>
                        <div class="button-hover-effect"></div>
                    </button>
                </div>

                <div class="divider animate__animated animate__fadeInUp animate__delay-6s">
                    <span>OR SIGN UP WITH</span>
                </div>

                <div class="social-login animate__animated animate__fadeInUp animate__delay-7s">
                    <div class="social-buttons">
                        <button type="button" class="social-button google">
                            <i class="fab fa-google"></i>
                        </button>
                        <button type="button" class="social-button facebook">
                            <i class="fab fa-facebook-f"></i>
                        </button>
                        <button type="button" class="social-button twitter">
                            <i class="fab fa-twitter"></i>
                        </button>
                    </div>
                </div>
            </form>

            <div class="login-footer animate__animated animate__fadeInUp animate__delay-8s">
                <p>Already have an account? <a [routerLink]="'/auth/login'" class="register-link">Sign in</a></p>
                <div class="footer-links">
                    <a href="#">Terms</a>
                    <a href="#">Privacy</a>
                    <a href="#">Help</a>
                </div>
            </div>
        </div>
    </div>
</div>